import { isIOS, isMacOs } from 'react-device-detect'
import { ILocation } from 'types/home-page'
import { ICategoryTileData, IValueItemData } from '../../graphql/types'
import { StoresIcons } from '../templates/types'
import { ILink, ILinkGroup, StoreIcon, StoreProvider } from '../types/locale'
import {
  ContentfulCategoryPageQuery,
  ContentfulMainQuery,
} from '../../graphql/generated-types'

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}
export const uppercaseWords = (str: string) =>
  str.replace(/^(.)|\s+(.)/g, (c) => c.toUpperCase())

export function isAppleOs() {
  return isIOS || isMacOs
}
export function getLangFromPrefix(prefix: string) {
  return prefix.replace('/', '').slice(0, 2)
}

export function mapContentfulCategoriesToCategoriesTileData(
  data: ContentfulMainQuery['categoriesData']['categoriesSection']['data']
): ICategoryTileData[] {
  return data.map(({ id, name, slug, tileImage }) => ({
    id,
    name,
    img: tileImage,
    pathname: slug,
  }))
}

export function mapContentfulSubCategoriesToCategoriesTileData(
  data: ContentfulCategoryPageQuery['contentfulCategory']['subCategories']['data']
): ICategoryTileData[] {
  return data.map(({ id, name, description, image }) => ({
    id,
    name,
    img: image,
    description,
  }))
}

export function mapContentfulStoresIcons(
  data: ContentfulMainQuery['sharedPageData']['storesIcons']['white' | 'black']
): StoreIcon[] {
  return data.map(({ link, icon }) => ({
    id: link.type as StoreProvider,
    icon: icon.file.url,
    link: link.link,
  }))
}

export function mapContentfulStoreIconsToColorsSet({
  black,
  white,
}: StoresIcons) {
  return {
    white: white ? mapContentfulStoresIcons(white) : undefined,
    black: mapContentfulStoresIcons(black),
  }
}

export function mapContentfulLocations(
  data: ContentfulMainQuery['locationsData']['locations']['data']
): ILocation[] {
  return data.map(({ id, name, slug }) => ({
    id,
    name,
    path: slug,
  }))
}

export function mapContentfulValues(
  data: ContentfulMainQuery['sharedPageData']['valuesListSection']['values']
): IValueItemData[] {
  return data.map(({ id, icon, title, description }) => ({
    id,
    icon: icon.file.url,
    heading: title,
    description: description.description,
  }))
}

export function mapContentfulBrandLogos(
  data: ContentfulMainQuery['sharedPageData']['asSeenInSection']['brandLogos']
): { alternativeText: string; image: string }[] {
  return data.map(({ image, alternativeText }) => ({
    alternativeText,
    image: image.file.url,
  }))
}

export function mapContentfulLinks(
  data: ContentfulMainQuery['sharedPageData']['legalLinks']
): ILink[] {
  return data.map(({ id, text, link }) => ({
    id,
    text,
    url: link.url,
    icon: link?.icon?.file.url,
  }))
}

export function mapContentfulLinksGroups(
  data: ContentfulMainQuery['sharedPageData']['linksGroups']
): ILinkGroup[] {
  return data.map(({ id, name, links }) => ({
    id,
    groupName: name,
    links: mapContentfulLinks(links),
  }))
}
